import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page21() {
  useEffect(() => {
    document.title = "Маяк — Страница 20"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page19" />
        <ForwardLink href="/page21" />
      </div>

      <p style={{ textAlign: "right" }}>20.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Да, он сошел с ума. Сначала<br/>
        странность. Замкнутость. Затем дикие<br/>
        фантазии поразили его. Бред<br/>
        о сиренах, мерфолках, дурных знамениях<br/>
        и тому подобном. В конце концов разума в нем<br/>
        осталось не больше, чем в курином зубе. Он<br/>
        верил, что в свете маяка<br/>
        есть какая-то магия.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Он полагал, что сам Св. Эльм разжег<br/>
        в его душе священный огонь. Спасение, – сказал<br/>
        он.
      </p>
      <p>МОЛОДОЙ смеется.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Байки.
      </p>
      <p>Он скручивает сигарету.</p>
      <p>СТАРИК пьет еще. Постепенно его настроение становится мрачным.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Я видел, как ты спарринговался с чайкой.
      </p>
      <p>МОЛОДОЙ лижет бумагу.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Лучше оставь их в покое. Убить чайку –<br/>
        к беде.
      </p>
      <p>МОЛОДОЙ смеется, беспечно.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Очередные байки?
      </p>
      <p>
        Когда МОЛОДОЙ начинает подносить сигарету к губам... СТАРИК ВСТАЕТ<br/>
        И ДАЕТ ЕМУ <u>СИЛЬНУЮ</u> ПОЩЕЧИНУ, из ниоткуда!
      </p>
      <p>
        МОЛОДОЙ стоит в шоке, опрокинув стул<br/>
        на пол... Он смотрит на СТАРИКА, ошарашенный... МОЛОДОЙ поднимает кулак,<br/>
        защищаясь...
      </p>
      <p>СТАРИК ЗОЛ. ОЧЕНЬ СЕРЬЕЗЕН.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Убить чайку – к беде.
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "right" }}>20.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page19" />
        <ForwardLink href="/page21" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710013129/the-lighthouse-script/jibvnwnjn510fbkvi78r.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page21;
